export const NEWS_ID_NEW = 'add';
